<template>
  <el-dialog title="微信支付" :visible.sync="dialogVisible" width="500px" @close="closeDialog">
    <template slot="title">
      <div style="margin: 20px;font-size: 18px;font-weight: 600">
        微信支付
      </div>
    </template>
    <div style="display: flex;flex-direction: column;text-align: center;align-items: center;">
      <div style="margin-bottom: 15px;">
        <span style="font-size: 16px">支付金额</span>
        <span style="color: #ff7736;font-size: 20px;">￥{{ price }}</span>
      </div>
      <div class="qr_code_body">
        <img :src="codeImg" style="width: 175px;height: 175px"/>
      </div>
      <div style="display: flex;align-items: center;column-gap: 10px;color: #7b7b7c;margin-top: 10px">
        <i class="iconfont icon-saoyisao" style="font-size: 38px"/>
        <div>
          <div style="margin-bottom: 4px;">打开手机微信</div>
          <div>扫一扫二维码</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Qrcode from 'qrcode'

export default {
  data () {
    return {
      dialogVisible: false,
      codeImg: '',
      price: '189',
      myTimer: null,
      outerOrderId: ''
    }
  },
  methods: {
    init (url, price, outerOrderId) {
      Qrcode.toDataURL(url).then(u => {
        this.codeImg = u
        this.price = price
        this.outerOrderId = outerOrderId
        this.myTimer = setInterval(() => {
          this.checkOrderIsPaid()
        }, 1000)
        this.dialogVisible = true
      }).catch(e => {
        console.log(e)
      })
    },
    async checkOrderIsPaid () {
      let partnerCode = this.$commonUtil.getPartnerInfo().partnerCode
      const {data: result} = await this.$http.get(`/b2b/web/orderIsPaid?partnerCode=${partnerCode}&outerOrderId=${this.outerOrderId}`)
      if (result.code !== 200) return
      if (result.data) {
        clearInterval(this.myTimer)
        this.$message.success('下单成功！')
        await this.$router.push('/orderManage/OrderList')
      }
    },
    closeDialog () {
      clearInterval(this.myTimer)
    }
  }
}
</script>

<style scoped lang="less">
.qr_code_body {
  width: 200px;
  height: 200px;
  padding: 12.5px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
}

/deep/ .el-dialog__header {
  background-color: #FFFFFF !important;
  border-bottom: 1px #eaeaea;
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/WXPayDialog.vue